import type { AppStoreConfig } from "@intrasync/stores";
import { castStoneAppStores } from "@intrasync/cast-stone";

/**
 * View stores from `@intrasync/cast-stone`. The package exports its view
 * stores pre-shaped as `{ name, store }[]` (currently just
 * `castStoneViewStore` → CastStoneViewStore). The `name` is a public contract
 * — components inside the package inject by it — so we spread the package's
 * list verbatim instead of re-declaring the names here. The cast narrows the
 * package's deliberately-loose `store: unknown` back to the constructor shape
 * RootStore mounts (`new store(rootStore)`).
 */
const castStoneStoreList: AppStoreConfig[] = castStoneAppStores as AppStoreConfig[];

export default castStoneStoreList;
